export enum Warning {
  HARD_CODED_VALUE_WARNING = 'HARD_CODED_VALUE_WARNING',
  HARD_CODED_EXCEPTION_WARNING = 'HARD_CODED_EXCEPTION_WARNING',
  UNEXPECTED_VALUE_WARNING = 'UNEXPECTED_VALUE_WARNING',
}
